import { fg } from '@atlaskit/platform-feature-flags/fg';

import {
	type ActivitiesData,
	type ActivityFilters,
	type ActivityQuery,
} from '../../../common/types';
import { fetchActivitiesWithExperience } from '../../../common/utils/analytics/utils';
import { ActivityClient } from '../base';

import { fetchActivitiesV2 } from './fetch-activities';

export class ActivityClientV2 extends ActivityClient {
	constructor(product?: string, baseUrl?: string, collabContextId?: string) {
		super('v2', product, undefined, baseUrl, collabContextId);
	}

	fetchActivities = async (
		retryMS: number[],
		filters: ActivityFilters,
		activityQueries: ActivityQuery[],
	): Promise<ActivitiesData> => {
		const filtersWithCollabContext =
			this.collabContextId && fg('platform_recent_work_collab_context_id')
				? { ...filters, collabContextId: this.collabContextId }
				: filters;

		return fetchActivitiesWithExperience(
			(experience) =>
				fetchActivitiesV2({
					experience,
					product: this.product,
					retryMS,
					filters: filtersWithCollabContext,
					activityQueries,
					baseUrl: this.baseUrl,
				}),
			'v2',
		);
	};

	setProduct = (product: string): void => {
		this.product = product;
	};
}
